import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class MachineReferenceService extends BaseReferenceService {
  constructor() {
    super('MachineReference');
  }

  // The machines serving one production process - a weaving job offers looms, a warping
  // job offers warping machines (R12, Steve 2026-09-07).
  getForProcess(productionProcessId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForProcess/${productionProcessId}`);
  }
}
